module.exports = __webpack_public_path__ + "img/supportTickets-img.5c2dfb72.svg";